<div class="table-wrapper" linPerfectScrollbar>
  <div class="table-container">
    <mat-table class="linxio-table" [dataSource]="dataSource || []">
      <ng-content></ng-content>
    </mat-table>
  </div>
</div>
